import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';

export const OPERATION_NOT_AUTHORIZED_ACTION = new InjectionToken<
  (message: string) => void
>('Operation not authorized action');

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    @Optional()
    @Inject(OPERATION_NOT_AUTHORIZED_ACTION)
    private action: (message: string) => void
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error

          let innerMessage = '';
          if (
            error.status === 403 &&
            error.error &&
            (error.error.title || error.error.detail)
          ) {
            innerMessage = $localize`License Error.` + ' ';
            if (error.error.title) {
              innerMessage = innerMessage + error.error.title;
              if (error.error.detail) {
                innerMessage = innerMessage + ': ';
              }
            }
            innerMessage = innerMessage + error.error.detail;
          } else if (error.status === 401 && error.error && error.error.title) {
            innerMessage = error.error.title;
          } else {
            innerMessage =
              error.error && (error.error as any).Message
                ? (error.error as any).Message
                : error.message
                ? error.message
                : '';
          }
          if (
            error.status !== 401 ||
            innerMessage.includes('The operation was not authorized.')
          ) {
            this.action(innerMessage);
          }
        }
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        console.log(errorMessage);
        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
